'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$37() {
  this.bgI = null;
  this.bgG = null;
  this.bgH = false;
  this.bgE = null;
  this.bgF = false;
  this.bgJ = false;
  this.bgK = false;
  this.bgI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$37 as $c_Lpresto_PrestoRouter$$anon$37 };
$p = $c_Lpresto_PrestoRouter$$anon$37.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$37;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$37() {
}
export { $h_Lpresto_PrestoRouter$$anon$37 as $h_Lpresto_PrestoRouter$$anon$37 };
$h_Lpresto_PrestoRouter$$anon$37.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bgI;
});
$p.t = (function() {
  if ((!this.bgH)) {
    this.bgG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("str", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bgH = true;
  }
  return this.bgG;
});
$p.ad = (function() {
  if ((!this.bgF)) {
    this.bgE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bgF = true;
  }
  return this.bgE;
});
$p.v = (function() {
  if ((!this.bgK)) {
    this.bgJ = false;
    this.bgK = true;
  }
  return this.bgJ;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$37 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$37, "presto.PrestoRouter$$anon$37", ({
  Oc: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$37 as $d_Lpresto_PrestoRouter$$anon$37 };
//# sourceMappingURL=presto.-Presto-Router$$anon$37.js.map
